<template>
    <div class="pb-10">
        <v-row dense>
            <v-col cols="12" md="2">
                <span class="text-h6 text--secondary">
                    {{ $t('key_facts') }}
                </span>
            </v-col>
            <v-col cols="12" md="8">
                <v-radio-group v-model="contract.unitPricingType" density="compact" hide-details class="pb-2">
                    <v-radio :label="$t(`product.info.service`)" value="SERVICE" color="primary" data-cy="SERVICE" />
                    <v-radio :label="$t(`product.info.tourist`)" value="TOURIST" color="primary" data-cy="TOURIST" />
                </v-radio-group>
                <div class="text-subtitle-1 font-weight-medium pb-2">{{ $t('service_provided') }}</div>
                <v-radio-group v-model="contract.allLocations" density="compact" hide-details class="pb-2">
                    <v-radio :label="$t('everywhere')" :value="true" color="primary" data-cy="everywhere" />
                    <v-radio
                        :label="$t('select_from_list')"
                        :value="false"
                        color="primary"
                        data-cy="select-from-list"
                    />
                </v-radio-group>
                <v-row v-if="!contract.allLocations" dense>
                    <v-col cols="12" md="8" class="pb-8">
                        <InfoLocationForm v-model="contract.locations" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script setup lang="ts">
    import InfoLocationForm from '~/components/products/information/InfoLocationForm.vue'

    const contract = defineModel<any>()
</script>
